// extracted by mini-css-extract-plugin
export default {"standardContainerColor":"UQU2v47Mqzj2tgB_CyBe","supplementaryContainerColor":"eArN6SbEQzeSu2QNuoY1"};